import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-settings__content-item" }
const _hoisted_2 = { class: "main-settings__upload-image-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " jpg/png files less than 500KB ", -1 /* HOISTED */)
const _hoisted_4 = { class: "main-settings__upload-image-preview" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "main-settings__availability-for-organics" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-info" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "main-settings__confirm-button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_SegmentsAutocompleteMultiselect = _resolveComponent("SegmentsAutocompleteMultiselect")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "geoMultiMethodMainSettingsFormRef",
    "label-position": "top",
    model: _ctx.geoMultiMethod,
    rules: _ctx.mainSettingsFormRules,
    onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setFormChanged(true)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form_item, {
            label: "Currency",
            prop: "currency"
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_select, {
                modelValue: _ctx.geoMultiMethod.currency,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.geoMultiMethod.currency) = $event)),
                placeholder: "Select currency",
                disabled: !!_ctx.geoMultiMethod.multiMethodId
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencyList, ({ code: currencyCode }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: currencyCode,
                      label: currencyCode,
                      value: currencyCode
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue", "disabled"])), [
                [_directive_loading, _ctx.isCurrencyListLoading]
              ]),
              _createVNode(_component_el_text, { type: "info" }, {
                default: _withCtx(() => [
                  _createTextVNode(" The currency cannot be changed after saving ")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "Public name",
            prop: "publicName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.geoMultiMethod.publicName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.geoMultiMethod.publicName) = $event)),
                placeholder: "Enter method public name",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFormChanged(true)))
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_form_item, {
            label: "Image",
            prop: "imageId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_upload, {
                "auto-upload": "",
                "on-remove": _ctx.clearImage,
                "http-request": _ctx.uploadImage,
                "show-file-list": false,
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFormChanged(true)))
              }, {
                tip: _withCtx(() => [
                  _hoisted_3
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Click to upload ")
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["on-remove", "http-request"])
            ]),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.geoMultiMethod.filePath)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.geoMultiMethod.filePath,
                  alt: "Payment method logo",
                  class: "main-settings__upload-image-preview-image"
                }, null, 8 /* PROPS */, _hoisted_5))
              : _createCommentVNode("v-if", true)
          ])
        ])), [
          [_directive_loading, _ctx.isImageUploading]
        ])
      ]),
      _createVNode(_component_el_form_item, {
        label: "Included segments",
        prop: "segmentList"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SegmentsAutocompleteMultiselect, {
            modelValue: _ctx.geoMultiMethod.segmentList,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.geoMultiMethod.segmentList) = $event)),
            "is-collapse-tags-enabled": false,
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setFormChanged(true)))
          }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_form_item, {
        label: "Excluded segments",
        prop: "excludedSegmentList"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SegmentsAutocompleteMultiselect, {
            modelValue: _ctx.geoMultiMethod.excludedSegmentList,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.geoMultiMethod.excludedSegmentList) = $event)),
            "is-collapse-tags-enabled": false,
            onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setFormChanged(true)))
          }, null, 8 /* PROPS */, ["modelValue"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_el_form_item, { prop: "organic" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.geoMultiMethod.organic,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.geoMultiMethod.organic) = $event)),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.setFormChanged(true)))
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode(_component_el_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Availability for organics "),
                _createVNode(_component_el_tooltip, { content: "If turned on, the payment method is available for organic users." }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: _ctx.TagComponentTypes.PRIMARY,
          disabled: _ctx.isSaveActionDisabled || !_ctx.isUnsavedChanges,
          onClick: _ctx.saveGeoMultiMethodMainSettings
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isUnsavedChanges ? 'Save changes' : 'Saved'), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["type", "disabled", "onClick"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model", "rules"]))
}